import "./explainer-card";

import { Storybook } from "@tento-ui/ui/storybook";
import { NuxExplainerCard } from "./explainer-card";
import { $makeHomeCard } from "@tento-ui/components/home-card/home-grid-card.example";
import { Tracing } from "@tento-core/tracing";

const exampleCallbacks: NuxExplainerCard.Callbacks = {
  onStart: () => Tracing.dev("storybook", "Start now clicked"),
};

export class NuxExplainerCardStoryBook extends Storybook.Default {
  title(): string {
    return "Nux Explainer Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "In Context",
        render: () =>
          $makeHomeCard({
            title: "Start here",
            contentBg: "var(--bg-surface-light-opaque)",
            $cardContent: NuxExplainerCard.makeWith(exampleCallbacks),
          }),
      },
      {
        title: "Raw",
        render: () => NuxExplainerCard.makeWith(exampleCallbacks),
      },
    ];
  }
}
